import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';

import { Language } from 'ha/i18n';

export enum ActionTypes {
  SET = 'LANGUAGE_SWITCHER/SET_LOCASISED_LOCATIONS',
}

export const Actions = {
  set: (
    localisedLocations: Array<{ code: Language; localisedLocation: string }>,
  ) => createAction(ActionTypes.SET, localisedLocations),
};

export type Actions = ActionsUnion<typeof Actions>;
